import tenant from "@/store/tenant";

export default {
  namespaced: true,
  ntechlab: {
    title: "Ntechlab",
    provider: "Provider",
    provider_section: "Select a provider",
    master_account: {
      title: "Master Account",
      name: "Name",
      description: "Description",
      api_user: "Api User",
      api_password: "Api Password",
      api_server: "Api Server",
      sync_data: "Sync Data",
      sync_data_success: "Data successfully synced",
      sync_data_error: "Error syncing data",
    },
    watch_list: {
      title: "List",
      name: "Name",
      comment: "Comment",
      color: "Color",
      camera_group: "Camera Group",
      master_account: "Master Account",
      enable_schedule_disable: "Program Schedule",
      disable_schedule: "Disable Schedule",
      notify: "Notify",
      acknowledge: "Acknowledge",
      face_threshold: "Face Threshold",
      body_threshold: "Body Threshold",
      car_threshold: "Car Threshold",
      ignore_events: "Ignore Events",
      send_events_to_external_vms: "Send Events to External VMS",
      active_after: "Active After",
      active_before: "Active Before",
      disable_schedule_active: "Disable Schedule Active",
      disable_schedule_monday: "Disable Schedule Monday",
      disable_schedule_tuesday: "Disable Schedule Tuesday",
      disable_schedule_wednesday: "Disable Schedule Wednesday",
      disable_schedule_thursday: "Disable Schedule Thursday",
      disable_schedule_friday: "Disable Schedule Friday",
      disable_schedule_saturday: "Disable Schedule Saturday",
      disable_schedule_sunday: "Disable Schedule Sunday",
      master_account_name: "Master Account Name",
      default_configuration: "Default Configuration",
      title_schedule_disable: "Schedule Disable 00:00 - 00:00",
      info: "Info",
      reconogition_config: "Recognition Config",
      schedule_settings: "Disable Schedule",
      type_alarm: "Type Alarm",
    },
    face: {
      image: "Image",
      name: "Name",
      active: "Active",
      comment: "Comment",
      master_account: "Master Account",
      watch_list: "Watch List",
      created_at: "Created At",
      updated_at: "Updated At",
      title: "Faces",
      features: "Features",
      already_face_added: "Face already added",
      face_added_label: "Added",
    },
    camera: {
      title: "Cameras",
      name: "Name",
      active: "Active",
      comment: "Comment",
      camera_group: "Camera Group",
      created_at: "Created At",
      updated_at: "Updated At",
      refresh: "Refresh",
      camera: "Camera",
      status: "Status",
    },
    face_search: {
      title: "Face Search",
      search: "Search",
      change_search: "Change Search",
      no_results_found: "No results found",
      no_face_detected: "No face was detected in the image",
      delete_image: "Delete Image",
      full_image: "Full Image",
      invalid_format: "Invalid format, only .jpg, .jpeg or .png images are accepted",
      max_size: "The image must not be larger than 2 MB",
      drag_to_map: "Drag to see the location",
      camera_without_location: "The camera has no facility or coordinates registered",
    }
  }
};
